import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShowCurrentAutoplayOutputDto } from '../../api/gameApi';

export interface AutoplayliceState {
  currentAutoplay?: ShowCurrentAutoplayOutputDto & {
    countAfterStopped?: number;
  };
  currentAutoplayLoading: boolean;
  enabledPooling: boolean;
}

const initialState: AutoplayliceState = {
  currentAutoplay: undefined,
  currentAutoplayLoading: true,
  enabledPooling: true,
};

const autoplaySlice = createSlice({
  name: 'autoplay',
  initialState,
  reducers: {
    setCurrentAutoplay: (
      state,
      { payload }: PayloadAction<ShowCurrentAutoplayOutputDto | undefined>,
    ) => {
      state.currentAutoplay = payload;
    },
    setCurrentAutoplayLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.currentAutoplayLoading = payload;
    },
    setCurrentAutoplayStopStatus: (state) => {
      if (!state.currentAutoplay) return;

      state.currentAutoplay.status = 'stopped';
    },
    setCurrentAutoplayEnabledPooling: (state, { payload }: PayloadAction<boolean>) => {
      state.enabledPooling = payload;
    },
  },
});

export const {
  setCurrentAutoplay,
  setCurrentAutoplayLoading,
  setCurrentAutoplayStopStatus,
  setCurrentAutoplayEnabledPooling,
} = autoplaySlice.actions;

export default autoplaySlice.reducer;
